/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubscriptionStatusDetails } from './SubscriptionStatusDetails';
import {
    SubscriptionStatusDetailsFromJSON,
    SubscriptionStatusDetailsFromJSONTyped,
    SubscriptionStatusDetailsToJSON,
    SubscriptionStatusDetailsToJSONTyped,
} from './SubscriptionStatusDetails';
import type { SubscriptionAllowedActions } from './SubscriptionAllowedActions';
import {
    SubscriptionAllowedActionsFromJSON,
    SubscriptionAllowedActionsFromJSONTyped,
    SubscriptionAllowedActionsToJSON,
    SubscriptionAllowedActionsToJSONTyped,
} from './SubscriptionAllowedActions';

/**
 * 
 * @export
 * @interface GetSubscriptionStatusResponse
 */
export interface GetSubscriptionStatusResponse {
    /**
     * 
     * @type {SubscriptionStatusDetails}
     * @memberof GetSubscriptionStatusResponse
     */
    details?: SubscriptionStatusDetails;
    /**
     * 
     * @type {string}
     * @memberof GetSubscriptionStatusResponse
     */
    type: GetSubscriptionStatusResponseTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof GetSubscriptionStatusResponse
     */
    error: boolean;
    /**
     * 
     * @type {SubscriptionAllowedActions}
     * @memberof GetSubscriptionStatusResponse
     */
    actions?: SubscriptionAllowedActions;
}


/**
 * @export
 */
export const GetSubscriptionStatusResponseTypeEnum = {
    Free: 'free',
    Paid: 'paid'
} as const;
export type GetSubscriptionStatusResponseTypeEnum = typeof GetSubscriptionStatusResponseTypeEnum[keyof typeof GetSubscriptionStatusResponseTypeEnum];


/**
 * Check if a given object implements the GetSubscriptionStatusResponse interface.
 */
export function instanceOfGetSubscriptionStatusResponse(value: object): value is GetSubscriptionStatusResponse {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function GetSubscriptionStatusResponseFromJSON(json: any): GetSubscriptionStatusResponse {
    return GetSubscriptionStatusResponseFromJSONTyped(json, false);
}

export function GetSubscriptionStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSubscriptionStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'details': json['details'] == null ? undefined : SubscriptionStatusDetailsFromJSON(json['details']),
        'type': json['type'],
        'error': json['error'],
        'actions': json['actions'] == null ? undefined : SubscriptionAllowedActionsFromJSON(json['actions']),
    };
}

export function GetSubscriptionStatusResponseToJSON(json: any): GetSubscriptionStatusResponse {
    return GetSubscriptionStatusResponseToJSONTyped(json, false);
}

export function GetSubscriptionStatusResponseToJSONTyped(value?: GetSubscriptionStatusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'details': SubscriptionStatusDetailsToJSON(value['details']),
        'type': value['type'],
        'error': value['error'],
        'actions': SubscriptionAllowedActionsToJSON(value['actions']),
    };
}

